import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/Icons/checkbox-toggle.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1ec3c490"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "language",
  class: "language"
}
const _hoisted_2 = { class: "language_container" }
const _hoisted_3 = { class: "title_box" }
const _hoisted_4 = { class: "choose_language" }
const _hoisted_5 = { class: "lng_item_box" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "lng_name" }
const _hoisted_8 = { class: "img_box" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check_box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "checkbox-toggle"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$localization.getTranslate("ChooseLanguage")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Languages, (language, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: idx,
              class: _normalizeClass({ active: _ctx.currentLanguage === language.HtmlId })
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "lng_item",
                onClick: ($event: any) => (_ctx.ChangeLang(language))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("img", {
                      src: require(`../../../../assets/img/Icons/${language.ImageName}`),
                      alt: "gb"
                    }, null, 8, _hoisted_9)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$localization.getTranslate(language.Name)), 1)
                ]),
                _hoisted_10
              ], 8, _hoisted_6)
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}